(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kol-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-kol-gallery]').forEach((section) => {
      const track = section.querySelector('[data-kol-track]');
      const prev = section.querySelector('[data-kol-prev]');
      const next = section.querySelector('[data-kol-next]');
      const modal = section.querySelector('[data-kol-modal]');
      const modalInner = section.querySelector('[data-kol-modal-inner]');
      const modalFrame = section.querySelector('[data-kol-modal-frame]');
      const videos = Array.from(section.querySelectorAll('[data-kol-video]'));
      let resumeVideo = null;
      let userPrefersMuted = false;

      if (!track) return;

      const setCardPlaying = (video, isPlaying) => {
        const card = video.closest('.b8-kol-gallery__card');
        const playButton = card?.querySelector('[data-kol-play]');

        card?.classList.toggle('is-playing', isPlaying);
        playButton?.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      };

      const setVideoMuted = (video, isMuted) => {
        const card = video.closest('.b8-kol-gallery__card');
        const muteButton = card?.querySelector('[data-kol-mute]');

        video.muted = isMuted;
        muteButton?.setAttribute('aria-pressed', String(isMuted));
        muteButton?.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
      };

      const pauseVideo = (video, options = {}) => {
        if (!video) return;

        video.pause();

        if (options.mute !== false) {
          setVideoMuted(video, true);
        }

        setCardPlaying(video, false);
      };

      const pauseOtherVideos = (activeVideo) => {
        videos.forEach((video) => {
          if (video !== activeVideo) {
            pauseVideo(video);
          }
        });
      };

      const pauseAllVideos = () => {
        resumeVideo = null;
        videos.forEach((video) => pauseVideo(video));
      };

      const playVideo = (video) => {
        if (!video) return;

        pauseOtherVideos(video);
        setVideoMuted(video, userPrefersMuted);

        const playPromise = video.play();
        setCardPlaying(video, true);

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            if (!video.muted) {
              setVideoMuted(video, true);

              const mutedPlayPromise = video.play();
              setCardPlaying(video, true);

              if (mutedPlayPromise && typeof mutedPlayPromise.catch === 'function') {
                mutedPlayPromise.catch(() => setCardPlaying(video, false));
              }

              return;
            }

            setCardPlaying(video, false);
          });
        }
      };

      const getStep = () => {
        const card = track.querySelector('.b8-kol-gallery__card');
        if (!card) return 0;

        const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateNav = () => {
        if (!prev || !next) return;

        const maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      const scrollByCard = (direction) => {
        const step = getStep();
        if (!step) return;
        pauseAllVideos();
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      };

      prev?.addEventListener('click', () => scrollByCard(-1));
      next?.addEventListener('click', () => scrollByCard(1));
      track.addEventListener(
        'scroll',
        () => {
          updateNav();
          pauseAllVideos();
        },
        { passive: true }
      );
      window.addEventListener('resize', updateNav);
      updateNav();

      const closeModal = () => {
        if (!modal || !modalFrame) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        modalFrame.src = '';
      };

      modal?.addEventListener('click', closeModal);
      modalInner?.addEventListener('click', (event) => event.stopPropagation());

      videos.forEach((video) => {
        setVideoMuted(video, true);

        video.addEventListener('click', () => {
          if (video.paused) {
            playVideo(video);
          } else {
            pauseVideo(video, { mute: false });
          }
        });

        video.addEventListener('pause', () => setCardPlaying(video, false));
        video.addEventListener('play', () => setCardPlaying(video, true));
      });

      section.querySelectorAll('[data-kol-mute]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();

          const card = button.closest('.b8-kol-gallery__card');
          const video = card?.querySelector('[data-kol-video]');

          if (!video) return;

          userPrefersMuted = !video.muted;
          setVideoMuted(video, userPrefersMuted);
        });
      });

      if ('IntersectionObserver' in window) {
        const viewportObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio < 0.15) {
                const playingVideo = videos.find((video) => !video.paused);

                if (playingVideo) {
                  resumeVideo = playingVideo;
                  pauseVideo(playingVideo);
                }
              } else if (entry.intersectionRatio >= 0.4 && resumeVideo) {
                const videoToResume = resumeVideo;
                resumeVideo = null;
                playVideo(videoToResume);
              }
            });
          },
          { threshold: [0, 0.15, 0.4] }
        );

        viewportObserver.observe(section);
      }

      section.querySelectorAll('[data-kol-play]').forEach((button) => {
        button.addEventListener('click', () => {
          const youtubeId = button.dataset.kolYoutubeId;
          const shortUrl = button.dataset.kolShortUrl;

          if (youtubeId && modal && modalFrame) {
            modalFrame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeId)}?autoplay=1`;
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            return;
          }

          if (shortUrl) {
            const popup = window.open(shortUrl, '_blank', 'noopener,noreferrer');
            if (popup) popup.opener = null;
            return;
          }

          const card = button.closest('.b8-kol-gallery__card');
          const video = card?.querySelector('[data-kol-video]');

          if (!card || !video) return;

          if (video.paused) {
            playVideo(video);
          } else {
            pauseVideo(video, { mute: false });
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user-image"] && !Shopify.designMode) return;
  try {
    
  const initB8UserImageGrid = (container) => {
    if (!container) return;

    const cards = Array.from(container.querySelectorAll('.b8-user-image__card'));
    if (!cards.length) return;

    const mediaQuery = window.matchMedia('(max-width: 749px)');

    const sortCards = (isMobile) => {
      const sortAttr = isMobile ? 'data-mobile-order' : 'data-desktop-order';

      cards
        .sort((a, b) => {
          return (
            parseInt(a.getAttribute(sortAttr), 10) - parseInt(b.getAttribute(sortAttr), 10)
          );
        })
        .forEach((card) => container.appendChild(card));
    };

    sortCards(mediaQuery.matches);

    if (container.dataset.b8UserImageBound === 'true') return;
    container.dataset.b8UserImageBound = 'true';

    mediaQuery.addEventListener('change', (event) => {
      sortCards(event.matches);
    });
  };

  const bootB8UserImageGrids = () => {
    document.querySelectorAll('[id^="b8-user-image-grid-"]').forEach(initB8UserImageGrid);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootB8UserImageGrids, { once: true });
  } else {
    bootB8UserImageGrids();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const grid = event.target.querySelector('[id^="b8-user-image-grid-"]');
    if (grid) initB8UserImageGrid(grid);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-our-users-say"] && !Shopify.designMode) return;
  try {
    
  const initUsersSaySwiper = (root) => {
    const el = root.querySelector('[data-users-say-swiper]');
    if (!el || typeof Swiper === 'undefined') return;

    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    new Swiper(el, {
      slidesPerView: 1.5,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        750: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
    });
  };

  const bootAllUsersSaySwipers = () => {
    document.querySelectorAll('.b8-users-say').forEach(initUsersSaySwiper);
  };

  const bootWhenReady = () => {
    if (typeof Swiper === 'undefined') return false;
    bootAllUsersSaySwipers();
    return true;
  };

  const scheduleBoot = () => {
    if (bootWhenReady()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (bootWhenReady() || attempts >= 120) {
        window.clearInterval(timer);
      }
    }, 16);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleBoot, { once: true });
  } else {
    scheduleBoot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.b8-users-say');
    if (section) initUsersSaySwiper(section);
  });

  } catch(e) { console.error(e); }
})();
})();
